import {useEffect, useLayoutEffect, useContext} from 'react'
import {useLocation} from 'react-router-dom'

import DashboardLayout from './DashboardLayout'
import Layout from './Layout'
import {UserContext} from '../state/contexts'

import {connect} from '../state/hooks/tools'
import {EMAILS, TFA_CONFIGS, PASSWORDS, ROLES, INVITES, USERS, CLIENTS, SETTINGS} from '../state/actionTypes'
import {isEmpty} from '../lib/tools'
import {readEndpoint} from '../lib/asyncMethods'

const ApplicationLayout = props => {
  const {mode, setMode} = useContext(UserContext)
  const location = useLocation()
  const role = props.roles[0] || {}

  useEffect(() => {
    if (!isEmpty(props.currentUser)) {
      props.readEndpoint('emails')
      props.fetchTfaConfigs('tfa-configs')
      props.fetchPasswords('passwords')
      props.fetchRoles('roles')
      props.fetchSettings('settings')
    }
  }, [props.currentUser])

  useEffect(() => {
    if (!isEmpty(props.currentUser)&& role.name === 'admin') {
      props.fetchClients('clients?page=1')
      props.fetchUsers('users?page=1')
      props.fetchInvites('invites?page=1')
    } else if (!isEmpty(role)) {
      props.fetchClients('clients')
    }
  }, [role])

  useLayoutEffect(() => {
    if (location.pathname.includes('admin') && mode !== 'admin')
      setMode('admin')

    if (!location.pathname.includes('admin') && mode !== 'user')
      setMode('user')
  }, [mode, location.pathname])

  if (isEmpty(props.currentUser)) {
    return <Layout />
  } else {
    return <DashboardLayout />
  }
}

const mapStateToProps = ({users, roles}) => ({roles: [], ...users, ...roles})

const actionCreators = ({emails, tfa, passwords, roles, clients, users, invites, metadata}) => ({
  readEndpoint: readEndpoint(emails, EMAILS),
  fetchTfaConfigs: readEndpoint(tfa, TFA_CONFIGS),
  fetchPasswords: readEndpoint(passwords, PASSWORDS),
  fetchRoles: readEndpoint(roles, ROLES),
  fetchClients: readEndpoint(clients, CLIENTS),
  fetchUsers: readEndpoint(users, USERS),
  fetchInvites: readEndpoint(invites, INVITES),
  fetchSettings: readEndpoint(metadata, SETTINGS)
})

export default connect(mapStateToProps, actionCreators)(ApplicationLayout)
